import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";

import { Table } from "@pentabd/ui";
import {
  ButtonGroup,
  ErrorModal,
  InputDateControllerVertical,
} from "@components";
import { TableColumn } from "./TableColumn";

import { useNotifications } from "@hooks/notification/useNotifications";
import { TablePagination } from "@helpers/tablePagination";

export const NotificationsTable = () => {
  const { t } = useTranslation();
  const { control, register } = useForm();
  const { notifications, handleQuery } = useNotifications();
  const { total, data, page, size } = notifications || {};

  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [activeStatus, setActiveStatus] = useState<number | null>(0);

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  const btnGroupAction = (index: number) => {
    let isRead = null;
    setActiveStatus(index);
    switch (index) {
      case 0:
        isRead = null;
        break;
      case 1:
        isRead = true;
        break;
      case 2:
        isRead = false;
        break;
      default:
        isRead = null;
        break;
    }
    handleQuery("isRead", isRead);
  };

  const filterButtons = t("NOTIFICATIONS.FILTERS", {
    returnObjects: true,
  }) as string[];

  return (
    <div>
      {isErrorModalOpen && (
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
          subtitle="Failed to view notification"
        />
      )}
      <Table
        columns={TableColumn(t, setIsErrorModalOpen)}
        rows={data || []}
        pagination={TablePagination({ total, size, page }, handleQuery)}
        headerExtension={{
          leftComponents: [
            <ButtonGroup
              key="btn-group"
              btnGroupData={filterButtons}
              activeState={activeStatus}
              action={btnGroupAction}
            />,
          ],
          rightComponents: [
            <div className="row mt-2">
              <InputDateControllerVertical
                control={control}
                label="NOTIFICATIONS.TABLE.FORM.START_DATE"
                name="startDate"
                register={{
                  ...register("startDate"),
                }}
                onSelectDate={(date) => {
                  if (date) {
                    handleQuery("startDate", date);
                  } else {
                    handleQuery("startDate", null);
                  }
                }}
                portal
                cols={6}
                withoutLabel
              />
              <InputDateControllerVertical
                control={control}
                label="NOTIFICATIONS.TABLE.FORM.END_DATE"
                name={"endDate"}
                register={{
                  ...register("endDate"),
                }}
                onSelectDate={(date) => {
                  if (date) {
                    handleQuery("endDate", date);
                  } else {
                    handleQuery("endDate", null);
                  }
                }}
                portal
                cols={6}
                withoutLabel
              />
            </div>,
          ],
        }}
      />
    </div>
  );
};
